import React from "react";
import { Switch, Route } from "react-router-dom";

import NotFound from '../NotFound';
import Dashboard from './Dashboard';
import Schoolfee from "./schoolfees/Schoolfee";
import Chartaccount from "./chartaccounts/Chartaccount";
import Gift from "./gifts/Gift";
import Accountingbalance from "./accountingbalances/Accountingbalance";
import Expense from "./expenses/Expense";
import Wage from "./wages/Wage";
import Schoolfeecategory from "./schoolfeecategories/Schoolfeecategory";
import Login from "../../partials/Login";
import Typesalary from "./typesalaries/Typesalary";
import Trash from "./trashs/Trash";
import Schoolfees from "./schoolfees/Schoolfrees";
import Report from "./reports/Report";
import SchoolfreeDette from "./schoolfees/SchoolfreeDette";
import Profile from "../users/Profile";
import StudentProfile from "../rh/students/Profile";
// import SchoolfeeStudent from "./students/SchoolfeeStudent";
import Search from "../users/Search";
import Sms from "./sms/Sms";
import Archive from "./archives/Archive";
import ArchiveDetail from "./archives/ArchiveDetail";
import SchoolfreeListClass from "./schoolfees/SchoolfreeListClass";
import SchoolfreeListMonth from "./schoolfees/SchoolfreeListMonth";
import Accoutingbalance from "./accountingbalances/Accoutingbalance";
import Formschoolfee from "./schoolfees/Formschoolfee";
 

var permissions = JSON.parse(localStorage.getItem("permissions"))
function handleCheck(val) {
    return  (permissions ?? []).some(item => val === item.permission);
}

function RouterPage(){

    return(
        <Switch>
            {
                handleCheck("Afficher comptabilité") == true && (
                    <Route exact path="/" component={Dashboard} />
                )
            }
            {
                handleCheck("Afficher paiement") == true && (
                    <Route exact path="/schoolfees/category/:schoolfeecategory_id" component={Schoolfee} />
                )
            }
            {
                handleCheck("Afficher paiement") == true && (
                    <Route exact path="/schoolfeesall" component={SchoolfreeListClass} />
                )
            }

            {
                handleCheck("Afficher paiement") == true && (
                    <Route exact path="/schoolfeesmonths" component={ SchoolfreeListMonth } />
                )
            }

            {
                handleCheck("Afficher paiement") == true && (
                    <Route exact path="/schoolfees/:type" component={SchoolfreeDette} />
                )
            }
            {/* {
                handleCheck("Afficher élève") == true && (
                    <Route  path="/students/:student_id" component={SchoolfeeStudent} />
                )
            } */}

            {
                handleCheck("Afficher élève") == true && (
                    <Route  path="/students/:studentId" component={StudentProfile} />
                )
            }

            {
                handleCheck("Afficher paiement") == true && (
                    <Route exact path="/formschoolfee" component={Formschoolfee} />
                )
            }

            {
                handleCheck("Afficher paiement") == true && (
                    <Route exact path="/schoolfees" component={Schoolfees} />
                )
            }
            {
                handleCheck("Afficher caisse") == true && (
                    <Route  path="/chartaccounts" component={Chartaccount} />
                )
            }

            {
                handleCheck("Ajouter élève") == true && (
                    <Route  path="/sms" component={Sms} />
                )
            }

            {
                handleCheck("Afficher don") == true && (
                    <Route  path="/gifts" component={Gift} />
                )
            }
            {
                handleCheck("Afficher caisse") == true && (
                    <Route  path="/accoutingbalances" component={Accoutingbalance} />
                )
            }
            {
                handleCheck("Afficher caisse") == true && (
                    <Route  path="/accountingbalances" component={Accountingbalance} />
                )
            }
            {
                handleCheck("Afficher depense") == true && (
                    <Route  path="/expenses" component={Expense} />
                )
            }
            {
                handleCheck("Afficher salaire") == true && (
                    <Route  path="/wages" component={Wage} />
                )
            }
            {
                handleCheck("Afficher corbeille") == true && (
                    <Route  path="/trash" component={Trash} />
                )
            } 
            {
                handleCheck("Afficher archive") == true && (
                    <Route  path="/archives/paiement/:year" component={ArchiveDetail} />
                )
            }
            {
                handleCheck("Afficher archive") == true && (
                    <Route  path="/archives" component={Archive} />
                )
            }

            {
                handleCheck("Afficher rapport") == true && (
                    <Route  path="/reports" component={Report} />
                )
            }
            
            {
                handleCheck("Afficher type de paiement") == true && (
                    <Route exact path="/schoolfeecategories" component={Schoolfeecategory} />
                )
            }

            {
                handleCheck("Afficher type de salaire") == true && (
                    <Route  path="/typesalaries" component={Typesalary} />
                )
            }

            <Route  path="/search/:search" component={ Search } />
            <Route  path="/get/:user_id" component={Login} />
            <Route  path="/login" component={Login} />
            <Route  path="/profile" component={Profile} />
            <Route component={NotFound} />
        </Switch>
    )
}

export default RouterPage;
